import React from 'react';
import { Link } from 'react-router-dom';

const KeanggotaanInfo = () => {
    return (
        <div className="min-h-screen bg-gray-50 pt-16 pb-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                        Bergabung dengan HEBITREN
                    </h1>
                    <p className="mt-4 text-xl text-gray-500">
                        Jadilah bagian dari ekosistem ekonomi dan bisnis pesantren terbesar di Indonesia. Bersama kita membangun kemandirian ekonomi umat.
                    </p>
                </div>

                {/* Persyaratan Section */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-12">
                    <div className="px-6 py-8 sm:p-10">
                        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                            <svg className="w-8 h-8 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Syarat Pendaftaran
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">Informasi Dasar</h3>
                                <ul className="space-y-3 text-gray-600">
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Identitas lengkap Pondok Pesantren
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Nama Pimpinan Pesantren
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Nama Penanggung Jawab Pesantren
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Lokasi (Provinsi, Kabupaten/Kota)
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Bidang usaha non-pendidikan yang dijalankan (satu atau lebih)
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-blue-500 mr-2">•</span> Badan hukum (opsional)
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">Dokumen</h3>
                                <div className="space-y-4">
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                                        <h4 className="font-medium text-blue-900">Logo Pesantren (wajib)</h4>
                                        <p className="text-sm text-blue-700 mt-1">Format: JPG, PNG, atau WEBP (Maks: 2MB)</p>
                                    </div>
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                                        <h4 className="font-medium text-blue-900">Akta atau SK Badan Hukum (opsional)</h4>
                                        <p className="text-sm text-blue-700 mt-1">Format: PDF (Maks: 5MB)</p>
                                    </div>
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                                        <h4 className="font-medium text-blue-900">Izin Kemenag, termasuk Nomor Statistik Pesantren (opsional)</h4>
                                        <p className="text-sm text-blue-700 mt-1">Format: PDF (Maks: 5MB). Dokumen opsional dapat dilengkapi nanti dari halaman status akun.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Alur Pendaftaran Section */}
                <div className="mb-16">
                    <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Alur Pendaftaran & Verifikasi</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
                        {/* Connecting Line */}
                        <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0"></div>
                        
                        <div className="relative z-10 bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center">
                            <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4 border-4 border-white shadow-sm">1</div>
                            <h3 className="text-lg font-bold text-gray-900 mb-2">Registrasi Online</h3>
                            <p className="text-sm text-gray-500">Isi formulir dan unggah dokumen persyaratan melalui portal ini.</p>
                        </div>
                        
                        <div className="relative z-10 bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center">
                            <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4 border-4 border-white shadow-sm">2</div>
                            <h3 className="text-lg font-bold text-gray-900 mb-2">Verifikasi Provinsi</h3>
                            <p className="text-sm text-gray-500">Data Anda akan ditinjau keabsahannya oleh pengurus tingkat wilayah/provinsi.</p>
                        </div>

                        <div className="relative z-10 bg-white p-6 rounded-xl shadow-sm border border-gray-100 text-center">
                            <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4 border-4 border-white shadow-sm">3</div>
                            <h3 className="text-lg font-bold text-gray-900 mb-2">Persetujuan Nasional</h3>
                            <p className="text-sm text-gray-500">Pengurus pusat akan menerbitkan Nomor Anggota resmi setelah lolos verifikasi akhir.</p>
                        </div>
                    </div>
                </div>

                {/* Call to Action */}
                <div className="bg-blue-600 rounded-2xl shadow-xl overflow-hidden">
                    <div className="px-6 py-12 sm:p-16 text-center">
                        <h2 className="text-3xl font-extrabold text-white mb-4">
                            Siap bergabung dengan kami?
                        </h2>
                        <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
                            Daftarkan pesantren Anda sekarang juga dan nikmati berbagai manfaat dalam pengembangan ekosistem bisnis pesantren secara digital.
                        </p>
                        <Link 
                            to="/daftar" 
                            className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10 transition-all shadow-sm hover:shadow-md"
                        >
                            Daftar Sekarang
                        </Link>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default KeanggotaanInfo;
